import React from "react";

import ReportInTimeRangeForm from "./reportInTimeRangeForm";
import DownloadAllReportsButton from "./downloadAllReportsButton";
import ResetReportButton from "./resetReportButton";
import LinkIconWrapper from "../../../shared/items/contols/linkIconWrapper";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";

import styles from "./reportContentTitle.module.scss";

const ReportTools = () => {
  return (
    <div className={styles.container_reportHeader}>
      <div className={styles.container_time}>
        <ReportInTimeRangeForm />
      </div>
      <div className={styles.container_links}>
        <div className={styles.container_linkItem}>
          <DownloadAllReportsButton />
        </div>
        <TooltipWrapper title="История просмотренных отчетов" position="top">
          <div className={styles.container_linkItem}>
            <LinkIconWrapper type="secondary" icon="history" link="/history-reports" />
          </div>
        </TooltipWrapper>
        {/* <TooltipWrapper title="Архив отчётов" position="top">
          <div className={styles.container_linkItem}>
            <LinkIconWrapper type="secondary" icon="bookmark" link="/saved-reports" />
          </div>
        </TooltipWrapper> */}
      </div>
    </div>
  );
};

export default React.memo(ReportTools);
